import script from "./GrantGroupDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrantGroupDialog.vue?vue&type=script&setup=true&lang=ts"

import "./GrantGroupDialog.vue?vue&type=style&index=0&id=ca6850d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca6850d0"]])

export default __exports__